export const ADD_TO_CART_SUCCESS='ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAIL='ADD_TO_CART_FAIL';
export const REMOVE_FROM_CART='REMOVE_FROM_CART';
export const REMOVE_ALL_ITEMS_FROM_CART='REMOVE_ALL_ITEMS_FROM_CART';
export const CLEAR_CART_ERRORS='CLEAR_CART_ERRORS'
export const ADD_SHIPPING_INFO='ADD_SHIPPING_INFO'
